import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { ProductsModule } from './components/pages/products/products.module';
import { ServisesModule } from './components/pages/servises/servises.module';
import { AboutModule } from './components/pages/about/about.module';

import { HomeComponent } from './components/home/home.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { AuthGuard } from './auth-guard/auth.guard';


const routes: Routes = [
  { path: 'home',             component: HomeComponent },

  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () => import('./components/pages/signin-signup/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'products',
    loadChildren: () => import('./components/pages/products/products.module').then(m => ProductsModule)
  }
  ,
  {
    path: 'services',
    loadChildren: () => import('./components/pages/servises/servises.module').then(m => ServisesModule)
  }
  ,
  {
    path: 'about',
    loadChildren: () => import('./components/pages/about/about.module').then(m => AboutModule)
  },
  {
    path: 'userprofile', component: UserProfileComponent, canActivate: [AuthGuard]
}

];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes,{
      useHash: true
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
